<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Leads</h2>
          </header>
        </div>
      </div>
      <div class="inputCard" v-if="loaded">
        <header>Form Submissions</header>
        <div class="content noselect">
          <div class="openMessageGrid">
            <div class="w3-border-right" id="leadsListContainer">
              <div v-for="(lead, index) in siteLeads" :key="index" @click="viewLead(lead.id)">
                <div class="leadPreview pointer" :class="[lead.id == selectedLeadID ? 'active' : '']">
                  <div>{{leadData(lead).name}}<span style="float:right; font-size:11px;">{{new Date(leadData(lead).created) | date({year: '2-digit',month: '2-digit',day: '2-digit',hour12: true,hour:'numeric',minute:'numeric'})}}</span></div>
                  <div :class="lead.status === 'new' ? 'font-weight-bold' : ''">{{leadData(lead).subject}}</div>
                </div>
              </div>
            </div>
            <div class="messageContainer">
              <div class="messageActions w3-bar border-bottom w3-light-grey" style="display:flex; justify-content:flex-end;">
                <button class="w3-bar-item w3-round w3-dark-blue" @click="markRead(selectedLeadID)">Mark as Read</button>
                <button class="w3-bar-item w3-round w3-red" @click="deleteLead(selectedLeadID)">Delete</button>
                <!-- <button class="w3-bar-item w3-round w3-blue">Export</button> -->
              </div>
              <div class="messageView">
                <div v-html="leadData((siteLeads[selectedLeadIndex(selectedLeadID)])).template"></div>
              </div>
              <hr/>
              <div class="replyView">
                <label class="w3-label">Reply:</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="replyContent"></tinymce-editor>
                <div style="display:flex; justify-content:flex-end;width:100%;">
                  <button class="w3-button w3-round w3-green w3-margin-top" :disabled="replyContent === ''" @click="sendReply()">Send</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsleads',
  data() {
    return {
      state: dataStore.state,
      selectedLeadID: 0,
      replyContent: '',
      loaded: false,
      timerRunning: false,
      timer: null
    }
  },
  computed: {
    siteLeads() {
      if (this.state.activeSite && this.state.activeSite.leads) {
        return this.state.activeSite.leads.sort((a,b) => {
          return JSON.parse(b.data).created - JSON.parse(a.data).created
        })
      } else {
        return false
      }
    }
  },
  created() {
    dataStore.getSiteLeads().then(() => {
      if (this.siteLeads.length) {
        this.selectedLeadID = this.siteLeads[0].id
        this.loaded = true
      }
    })
  },
  components: {
    'tinymce-editor': Editor
  },
  methods: {
    leadData(lead) {
      return JSON.parse(lead.data)
    },
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    selectedLeadIndex(id) {
      return this.siteLeads.findIndex((i) => {
        return i.id == id;
      })
    },
    viewLead(id) {
      this.selectedLeadID = id
      // this.replyContent = 'Hi ' + JSON.parse(selectedLead.data).name + ','
    },
    deleteLead(id) {
      if (confirm("Are you sure you want to DELETE this lead?")) {
        dataStore.deleteLead(id)
        this.selectedLeadID = this.siteLeads[0].id
        this.state.activeSite.leads.splice(this.state.activeSite.leads.findIndex((i) => {
          return i.id == id;
        }), 1);
      }
    },
    markRead(id) {
      dataStore.markRead(id).then(() => {
        // update view to show lead as read
      })
    },
    sendReply() {
      let selectedLead = this.siteLeads.find(lead => lead.id === this.selectedLeadID)
      let replyData = {
        domain: this.state.activeSite.domain,
        subject: JSON.parse(selectedLead.data).subject,
        mailto: JSON.parse(selectedLead.data).email,
        content: this.replyContent,
        site_name: this.state.siteData.site_name,
        site_email: this.state.siteData.contact.email,
        site_mailgun_key: this.state.siteData.site_mailgun_key,
        site_notification_email: this.state.siteData.contact.notification_email
      }
      dataStore.sendLeadReply(replyData).then((res) => {
        console.log(res)
      })
      this.markRead(this.selectedLeadID)
    }
  }
}
</script>

<style scoped>
  .newsTitle {font-size:1rem;}
  .newsMeta {font-size:1rem; font-family: 'Roboto', sans-serif; text-align: center;}
  .newsGrid {display:grid; grid-template-columns: 80px 1fr; grid-gap: 8px; border-bottom: 1px solid #ccc;}
  .newsGrid:last-child {border-bottom:0;}
  .newsContentGrid {display:grid; grid-template-columns: 1fr 250px 130px; grid-gap: 8px;}
  .buttons {text-align: right;}
  .inputCard header {text-align: left; padding-left:12px;}

  .openMessageGrid {display:grid; grid-template-columns: 1fr 3fr;}
  #leadsListContainer {max-height: 550px; overflow:hidden; overflow-y:scroll;}

  .leadsTableGrid {display:grid; grid-template-columns: 1fr 200px 100px 100px 100px; grid-gap: 8px;}
  .leadsTableGrid div {padding:8px;}

  .leadPreview {padding:8px; border-bottom: 1px solid #ccc;}
  .leadPreview.active {background:#dbedf7;}

  .messageView {padding:15px;}
  .messageActions {padding:4px;}
  .messageActions .w3-bar-item {margin-right: 4px;}

  .replyView {padding:15px;}

@media screen and (max-width:993px) {
  .newsTitle {font-size:10pt;}
  .newsMeta {font-size:10pt; font-family: 'Roboto', sans-serif; text-align: left;}
  .newsGrid {display:grid; grid-template-columns: 125px 1fr; grid-gap: 8px;}
  .newsContentGrid {grid-template-columns: 1fr;}
  .buttons {text-align: left;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsLeads.vue